<template>
  <div>
    <b-modal
      v-model="modalShow"
      @hidden="$emit('hidden')"
      size="lg"
    >
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center flex-fill">
          <h5 class="mb-0" v-if="record">Editar registro #{{record.id}}</h5>
          <h5 class="mb-0" v-else>Criar registro de trabalho</h5>

          <b-button class="ml-auto" size="sm" variant="link" @click="close()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>

      <template #default>
        <div class="row">
          <div class="col-md-12">
            <b-form-group
              label="Empresa"
              label-for="company-name"
            >
              <b-form-input
                id="company-name"
                v-model="form.companyName"
                placeholder="Informe um nome"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group
              label="Tipo de Regime"
              label-for="regime-type"
            >
              <b-form-select
                id="regime-type"
                v-model="form.regimeType"
                :options="[
                  { value: 'RPPS', text: 'RPPS' },
                  { value: 'RGPS', text: 'RGPS' }
                ]"
                required
              ></b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Estado"
              label-for="state-name"
            >
              <b-form-input
                id="state-name"
                v-model="form.state"
                placeholder="Informe o estado"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Cidade"
              label-for="city-name"
            >
              <b-form-input
                id="city-name"
                v-model="form.city"
                placeholder="Informe a cidade"
                required
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Data de ingresso"
              label-for="start-date"
            >
              <InputDatePicker v-model="form.ingressDate" />
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Data de Encerramento"
              label-for="end-date"
            >
              <InputDatePicker v-model="form.egressDate" />
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group
              label="Observação"
              label-for="observation"
            >
              <b-form-input v-model="form.observation" placeholder="Informe uma observação (opcional)" />
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isPublicService" switch inline class="my-2">
                Serviço público
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isTeaching" switch inline class="my-2">
                Magistério
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isCurrentCareer" switch inline class="my-2">
                Carreira Atual
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isCurrentPosition" switch inline class="my-2">
                Cargo Atual
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isSpecialTime" switch inline class="my-2">
                Tempo Especial
              </b-form-checkbox>
              <div v-if="form.isSpecialTime" class="mt-2">
                <b-form-select 
                  v-model="form.specialLevel" 
                  :options="[
                    { value: null, text: 'Selecione Tempo Especial', disabled: true },
                    { value: '15 anos', text: '15 anos' },
                    { value: '20 anos', text: '20 anos' },
                    { value: '25 anos', text: '25 anos' }
                  ]" 
                  size="sm" 
                  required
                ></b-form-select>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isPoliceTime" switch inline class="my-2">
                Tempo Policial
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isRuralTime" switch inline class="my-2">
                Tempo Rural
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="col-md-8">
            <b-form-group>
              <b-form-checkbox v-model="form.isDisabled" switch inline class="my-2">
                Com Deficiência
              </b-form-checkbox>

              <div v-if="form.isDisabled" class="mt-2">
                <b-form-select 
                  v-model="form.disabledLevel" 
                  :options="[{value: null, text: 'Selecione Gravidade', disabled: true }, { value: 'low', text: 'Leve' }, { value: 'medium', text: 'Moderada' }, { value: 'high', text: 'Grave' }]" 
                  size="sm" 
                  required
                ></b-form-select>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-12">
            <b-form-group>
              <b-form-checkbox v-model="form.isQualifyingPeriod" switch inline class="my-2">
                Considerar Carência
              </b-form-checkbox>
            </b-form-group>
          </div>

          <!-- <div class="col-md-8">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="form.expiredVacations" switch inline class="my-2">
                  Férias vencidas no período
                </b-form-checkbox>

                <div v-if="form.expiredVacation">
                  <b-form-input
                    v-model="form.expiredVacations"
                    type="number"
                    placeholder="Informe a quantidade"
                    required
                  ></b-form-input>
                </div>
              </div>
            </b-form-group>
          </div> -->

          <!-- <div class="col-md-8">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="form.hasExpiredPremiumLicenses" switch inline class="my-2">
                  Licença prêmio vencidas
                </b-form-checkbox>

                <div v-if="form.premiumLicense">
                  <b-form-input
                    v-model="form.expiredPremiumLicenses"
                    type="number"
                    placeholder="Informe a quantidade"
                    required
                  ></b-form-input>
                </div>
              </div>
            </b-form-group>
          </div> -->
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button
          variant="primary"
          @click="handleSave"
          :disabled="isSaving"
        >
          Salvar
        </b-button>

        <b-button
          variant="outline-primary"
          @click="cancel()"
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showConfirmationModal"
      title="Confirmar Alteração de Datas"
      @ok="confirmSave"
      @cancel="cancelConfirmation"
      ok-title="Confirmar"
      cancel-title="Cancelar"
    >
      <p>
        As datas de ingresso ou encerramento foram alteradas. 
        Isso pode afetar os cálculos de deduções.
      </p>
      <p>
        <strong>Lembre-se de verificar as deduções deste registro após salvar.</strong>
      </p>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import InputDatePicker from '@/components/InputDatePicker.vue';
import moment from 'moment';

export default {
  name: 'ModalWorkRecordsForm',

  components: {
    InputDatePicker,
  },

  props: {
    record: {
      type: Object,
    },
    parentId: {
      type: Number,
    },
  },

  data: () => ({
    isLoading: false,
    isSaving: false,
    modalShow: true,
    showConfirmationModal: false,
    originalDates: {
      ingressDate: null,
      egressDate: null,
    },
    form: {
      companyName: '',
      state: '',
      city: '',
      ingressDate: '',
      egressDate: '',
      isPublicService: false,
      isTeaching: false,
      expiredVacations: false,
      expiredVacations: 0,
      hasExpiredPremiumLicenses: false,
      expiredPremiumLicenses: 0,
      isCurrentPosition: false,
      isCurrentCareer: false,
      isSpecialTime: false,
        specialLevel: null,
      isDisabled: false,
      isQualifyingPeriod: true,
      isPoliceTime: false,
        isRuralTime: false,
      disabledLevel: null,
      regimeType: 'RPPS',
    },
  }),

  created() {
    if (this.record) {
      this.form = {
        ...this.record,
        ingressDate: this.record.ingressDate ? moment(this.record.ingressDate).utc().format('DD/MM/YYYY') : '',
        egressDate: this.record.egressDate ? moment(this.record.egressDate).utc().format('DD/MM/YYYY') : '',
      };
      
      this.originalDates = {
        ingressDate: this.record.ingressDate ? moment(this.record.ingressDate).utc().format('DD/MM/YYYY') : '',
        egressDate: this.record.egressDate ? moment(this.record.egressDate).utc().format('DD/MM/YYYY') : '',
      };
    }
  },

  methods: {
    hasDateChanged() {
      if (!this.record) return false;
      
      const currentIngressDate = this.form.ingressDate;
      const currentEgressDate = this.form.egressDate;
      
      return currentIngressDate !== this.originalDates.ingressDate || currentEgressDate !== this.originalDates.egressDate;
    },

    handleSave() {
      if (this.hasDateChanged() && this.hasDeductions()) {
        this.showConfirmationModal = true;
      } else {
        this.save();
      }
    },

    hasDeductions() {
      return (this.form.deduction1 && this.form.deduction1 > 0) ||
             (this.form.deduction2 && this.form.deduction2 > 0) ||
             (this.form.deduction3 && this.form.deduction3 > 0);
    },

    async confirmSave() {
      this.showConfirmationModal = false;
      await this.save();
    },

    cancelConfirmation() {
      this.showConfirmationModal = false;
    },

    async save() {
      this.isLoading = true;
      this.isSaving = true;

      try {
        await this.saveOrUpdate();

        this.$toast.open({
          message: 'Registro salvo com sucesso',
          type: 'success',
          position: 'top-right'
        });

        this.$emit('save');
        this.$emit('hidden');
      } catch (error) {
        this.$toast.open({
          message: 'Erro ao salvar',
          type: 'error',
          position: 'top-right'
        });
      } finally {
        this.isSaving = false;
        this.isLoading = false;
      }
    },

    saveOrUpdate() {
      const { form } = this;
      const body = { workRecord: form };

      if (!form.isDisabled) form.disabledLevel = null;
      if (!form.isSpecialTime) form.specialLevel = null;

      form.calculationId = this.parentId;

      if (form.id) {
        return axios.put(`/work-records/${form.id}`, body);
      } else {
        return axios.post('/work-records', body);
      }
    },
  }
}
</script>

<style scoped>
</style>
